import 'components/ordering/multiple-baskets/basket-transfer/basket-transfer-form.js'
import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { BasketTransferFormResetEvent } from 'components/ordering/multiple-baskets/basket-events.js'
import { slideInStyle } from 'components/ordering/multiple-baskets/basket.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'csc-basket-transfer-slide-in.prepare': { name: 'floppy-disk', style: 'light' },
})

@customElement('csc-basket-transfer-slide-in')
export class CSCBasketTransferSlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, slideInStyle]

  constructor() {
    super()
    this.addEventListener(BasketTransferFormResetEvent.type, () => this.slideIn.close())
  }

  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @property({ attribute: 'shop-id' })
  shopId = 0

  @property({ attribute: 'party-id' })
  partyId = 0

  @property({ attribute: 'user-id' })
  userId: null | number = null

  @query('cse-slide-in')
  slideIn!: CSESlideIn

  protected override render(): TemplateResult {
    return html`
      <cse-button
        variant="secondary"
        id="transfer-basket"
        @click="${() => this.slideIn.open()}">
        ${t('open_slide_in_button', { ns: 'csc-basket-transfer-slide-in', default: 'Transfer basket' })}

      </cse-button>

      <cse-slide-in>
        <div slot="header">
          ${t('header', { ns: 'csc-basket-transfer-slide-in', default: 'Transfer basket' })}
        </div>

        <cse-text>
          <cse-icon icon-role="csc-basket-transfer-slide-in.prepare" class="icon"></cse-icon>
        </cse-text>

        <cse-text class="description">
          ${t('description', { ns: 'csc-basket-transfer-slide-in', default: 'Transfer the basket to another user so they can use it right away.' })}
        </cse-text>

        <csc-basket-transfer-form
          ordering-endpoint="${this.orderingEndpoint}"
          shop-id="${this.shopId}"
          party-id="${this.partyId}"
          user-id="${this.userId}"
        ></csc-basket-transfer-form>
      </cse-slide-in>
    `
  }
}
